import {
  AdditiveBlending,
  BufferGeometry,
  Float32BufferAttribute,
  Line,
  LineBasicMaterial,
  Vector3,
} from 'three';

const startScratch = new Vector3();
const endScratch = new Vector3();

let tracerState = null;

export function initTracers(world, options = {}) {
  tracerState = {
    world,
    capacity: options.capacity ?? 96,
    tracers: [],
  };
  return tracerState;
}

export function spawnTracer(start, direction, options = {}) {
  const state = tracerState;
  if (!state) return null;
  if (state.tracers.length >= state.capacity) releaseTracer(0);

  startScratch.copy(start);
  startScratch.y = options.y ?? 1.12;
  endScratch.copy(startScratch).addScaledVector(direction, options.length ?? 8);

  const geometry = new BufferGeometry();
  geometry.setAttribute('position', new Float32BufferAttribute([
    startScratch.x, startScratch.y, startScratch.z,
    endScratch.x, endScratch.y, endScratch.z,
  ], 3));

  const material = new LineBasicMaterial({
    color: options.color ?? 0x53ffb5,
    transparent: true,
    opacity: options.opacity ?? 0.85,
    blending: AdditiveBlending,
    depthWrite: false,
  });
  const line = new Line(geometry, material);
  state.world.particleRoot.add(line);

  const tracer = { line, age: 0, ttl: options.ttl ?? 0.11 };
  state.tracers.push(tracer);
  return tracer;
}

export function updateTracers(dt) {
  const state = tracerState;
  if (!state) return;
  for (let i = state.tracers.length - 1; i >= 0; i -= 1) {
    const tracer = state.tracers[i];
    tracer.age += dt;
    tracer.line.material.opacity = Math.max(0, 1 - tracer.age / tracer.ttl);
    if (tracer.age >= tracer.ttl) releaseTracer(i);
  }
}

export function clearTracers() {
  const state = tracerState;
  if (!state) return;
  for (let i = state.tracers.length - 1; i >= 0; i -= 1) releaseTracer(i);
}

function releaseTracer(index) {
  const tracer = tracerState.tracers[index];
  tracerState.world.particleRoot.remove(tracer.line);
  tracer.line.geometry.dispose();
  tracer.line.material.dispose();
  tracerState.tracers.splice(index, 1);
}
